import axios from 'axios';

interface SettingsResponse {
  sucess: boolean;
  data: Array<{
    description: string;
    value: string;
  }>;
}

/*export async function getWhatsAppContacts(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/whatsapp_notification_numbers');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    try {
      return JSON.parse(valueStr);
    } catch {
      return [];
    }
  }

  return [];
}

export async function saveWhatsAppContacts(phoneNumbers: string[]): Promise<void> {
  const value = JSON.stringify(phoneNumbers);
  await axios.put('/settings/users/whatsapp_notification_numbers', {
    value,
  });
}

export async function getEmailRecipients(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/emails_pedidos_sem_faturamento_magento');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    if (valueStr) {
      return valueStr.split(',').map((email) => email.trim()).filter(Boolean);
    }
  }

  return [];
}

export async function saveEmailRecipients(emails: string[]): Promise<void> {
  const value = emails.join(',');
  await axios.put('/settings/users/emails_pedidos_sem_faturamento_magento', {
    value,
  });
}*/

export async function saveEmailRecipients(permissionName: string, emails: string[]): Promise<void> {
  const value = emails.join(',');
  await axios.put(`/settings/users/${permissionName}`, {
    value,
  });
}

export async function triggerUnbilledOrdersReport(): Promise<void> {
  await axios.post('/settings/users/emails_pedidos_sem_faturamento_magento');
}

export async function triggerReport(permissionName: string): Promise<void> {
  await axios.post(`/settings/users/${permissionName}`);
}


export async function getWhatsAppContacts(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/whatsapp_notification_numbers');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    try {
      return JSON.parse(valueStr);
    } catch {
      return [];
    }
  }

  return [];
}

export async function saveWhatsAppContacts(phoneNumbers: string[]): Promise<void> {
  const value = JSON.stringify(phoneNumbers);
  await axios.put('/settings/users/whatsapp_notification_numbers', {
    value,
  });
}

export async function getEmailRecipients(permissionName: string): Promise<string[]> {
  const response = await axios.get<SettingsResponse>(`/settings/users/${permissionName}`);

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    if (valueStr) {
      return valueStr.split(',').map((email) => email.trim()).filter(Boolean);
    }
  }

  return [];
}